/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Play_OptionsInputs */



/**
* | output |
* | --- |
* | "Basics" |
*
* @param {Og_Cfg_Play_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_play_options = /** @type {((inputs?: Og_Cfg_Play_OptionsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Play_OptionsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Général")
	if (locale === "es") return /** @type {LocalizedString} */ ("General")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Geral")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generale")
	return /** @type {LocalizedString} */ ("Basics")
});